export const GET_SKU_REQUEST = 'GET_SKU_REQUEST';
export const GET_SKU_SUCCESS = 'GET_SKU_SUCCESS';
export const GET_SKU_ERROR = 'GET_SKU_ERROR';
export const CREATE_SKUS_REQUEST = 'CREATE_SKUS_REQUEST';
export const CREATE_SKUS_SUCCESS = 'CREATE_SKUS_SUCCESS';
export const CREATE_SKUS_ERROR = 'CREATE_SKUS_ERROR';
export const DELETE_SKU_REQUEST = 'DELETE_SKU_REQUEST';
export const DELETE_SKU_SUCCESS = 'DELETE_SKU_SUCCESS';
export const DELETE_SKU_ERROR = 'DELETE_SKU_ERROR';
export const UPDATE_SKU_REQUEST = 'UPDATE_SKU_REQUEST';
export const UPDATE_SKU_SUCCESS = 'UPDATE_SKU_SUCCESS';
export const UPDATE_SKU_ERROR = 'UPDATE_SKU_ERROR';
export const CREATE_WORK_ORDERS_REQUEST = 'CREATE_WORK_ORDERS_REQUEST';
export const CREATE_WORK_ORDERS_SUCCESS = 'CREATE_WORK_ORDERS_SUCCESS';
export const CREATE_WORK_ORDERS_ERROR = 'CREATE_WORK_ORDERS_ERROR';
export const BULK_CREATE_WORK_ORDERS_REQUEST =
  'BULK_CREATE_WORK_ORDERS_REQUEST';
export const BULK_CREATE_WORK_ORDERS_SUCCESS =
  'BULK_CREATE_WORK_ORDERS_SUCCESS';
export const BULK_CREATE_WORK_ORDERS_ERROR = 'BULK_CREATE_WORK_ORDERS_ERROR';
export const DELETE_WORK_ORDER_REQUEST = 'DELETE_WORK_ORDER_REQUEST';
export const DELETE_WORK_ORDER_SUCCESS = 'DELETE_WORK_ORDER_SUCCESS';
export const DELETE_WORK_ORDER_ERROR = 'DELETE_WORK_ORDER_ERROR';
export const UPDATE_WORK_ORDER_REQUEST = 'UPDATE_WORK_ORDER_REQUEST';
export const UPDATE_WORK_ORDER_SUCCESS = 'UPDATE_WORK_ORDER_SUCCESS';
export const UPDATE_WORK_ORDER_ERROR = 'UPDATE_WORK_ORDER_ERROR';
export const GET_WORK_REQUEST = 'GET_WORK_REQUEST';
export const GET_WORK_SUCCESS = 'GET_WORK_SUCCESS';
export const GET_WORK_ERROR = 'GET_WORK_ERROR';
export const GET_NOMINAL_SPEED_REQUEST = 'GET_NOMINAL_SPEED_REQUEST';
export const GET_NOMINAL_SPEED_SUCCESS = 'GET_NOMINAL_SPEED_SUCCESS';
export const GET_NOMINAL_SPEED_ERROR = 'GET_NOMINAL_SPEED_ERROR';
export const CREATE_NOMINAL_SPEED_REQUEST = 'CREATE_NOMINAL_SPEED_REQUEST';
export const CREATE_NOMINAL_SPEED_SUCCESS = 'CREATE_NOMINAL_SPEED_SUCCESS';
export const CREATE_NOMINAL_SPEED_ERROR = 'CREATE_NOMINAL_SPEED_ERROR';
export const DELETE_NOMINAL_SPEED_REQUEST = 'DELETE_NOMINAL_SPEED_REQUEST';
export const DELETE_NOMINAL_SPEED_SUCCESS = 'DELETE_NOMINAL_SPEED_SUCCESS';
export const DELETE_NOMINAL_SPEED_ERROR = 'DELETE_NOMINAL_SPEED_ERROR';
export const UPDATE_NOMINAL_SPEED_REQUEST = 'UPDATE_NOMINAL_SPEED_REQUEST';
export const UPDATE_NOMINAL_SPEED_SUCCESS = 'UPDATE_NOMINAL_SPEED_SUCCESS';
export const UPDATE_NOMINAL_SPEED_ERROR = 'UPDATE_NOMINAL_SPEED_ERROR';
export const BULK_CREATE_NOMINAL_SPEEDS_REQUEST =
  'BULK_CREATE_NOMINAL_SPEEDS_REQUEST';
export const BULK_CREATE_NOMINAL_SPEEDS_SUCCESS =
  'BULK_CREATE_NOMINAL_SPEEDS_SUCCESS';
export const BULK_CREATE_NOMINAL_SPEEDS_ERROR =
  'BULK_CREATE_NOMINAL_SPEEDS_ERROR';
export const BULK_DELETE_SKUS_REQUEST = 'BULK_DELETE_SKUS_REQUEST';
export const BULK_DELETE_SKUS_SUCCESS = 'BULK_DELETE_SKUS_SUCCESS';
export const BULK_DELETE_SKUS_ERROR = 'BULK_DELETE_SKUS_ERROR';
export const BULK_DELETE_WORK_ORDERS_REQUEST =
  'BULK_DELETE_WORK_ORDERS_REQUEST';
export const BULK_DELETE_WORK_ORDERS_SUCCESS =
  'BULK_DELETE_WORK_ORDERS_SUCCESS';
export const BULK_DELETE_WORK_ORDERS_ERROR = 'BULK_DELETE_WORK_ORDERS_ERROR';
export const BULK_DELETE_NOMINAL_SPEEDS_REQUEST =
  'BULK_DELETE_NOMINAL_SPEEDS_REQUEST';
export const BULK_DELETE_NOMINAL_SPEEDS_SUCCESS =
  'BULK_DELETE_NOMINAL_SPEEDS_SUCCESS';
export const BULK_DELETE_NOMINAL_SPEEDS_ERROR =
  'BULK_DELETE_NOMINAL_SPEEDS_ERROR';
export const UPDATE_MACHINE_MAPPING_REQUEST = 'UPDATE_MACHINE_MAPPING_REQUEST';
export const UPDATE_MACHINE_MAPPING_SUCCESS = 'UPDATE_MACHINE_MAPPING_SUCCESS';
export const UPDATE_MACHINE_MAPPING_ERROR = 'UPDATE_MACHINE_MAPPING_ERROR';
export const BULK_UPDATE_MACHINE_MAPPING_REQUEST =
  'BULK_UPDATE_MACHINE_MAPPING_REQUEST';
export const BULK_UPDATE_MACHINE_MAPPING_SUCCESS =
  'BULK_UPDATE_MACHINE_MAPPING_SUCCESS';
export const BULK_UPDATE_MACHINE_MAPPING_ERROR =
  'BULK_UPDATE_MACHINE_MAPPING_ERROR';
export const RESET_FAILED_SKUS = 'RESET_FAILED_SKUS';
export const RESET_FAILED_WORK_ORDERS = 'RESET_FAILED_WORK_ORDERS';
export const RESET_FAILED_NOMINAL_SPEEDS = 'RESET_FAILED_NOMINAL_SPEEDS';
export const RESET_FAILED_MACHINE_MAPPINGS = 'RESET_FAILED_MACHINE_MAPPINGS';
export const SET_FAILED_WORK_ORDERS = 'SET_FAILED_WORK_ORDERS';

export const GET_WORK_ORDER_TARGET_REQUEST = 'GET_WORK_ORDER_TARGET_REQUEST';
export const GET_WORK_ORDER_TARGET_SUCCESS = 'GET_WORK_ORDER_TARGET_SUCCESS';
export const GET_WORK_ORDER_TARGET_ERROR = 'GET_WORK_ORDER_TARGET_ERROR';

export const GET_WORK_ORDER_TARGET_PAGINATED_REQUEST =
  'GET_WORK_ORDER_TARGET_PAGINATED_REQUEST';
export const GET_WORK_ORDER_TARGET_PAGINATED_SUCCESS =
  'GET_WORK_ORDER_TARGET_PAGINATED_SUCCESS';
export const GET_WORK_ORDER_TARGET_PAGINATED_ERROR =
  'GET_WORK_ORDER_TARGET_PAGINATED_ERROR';

export const CREATE_SKU_WITH_NOMINAL_SPEED_REQUEST =
  'CREATE_SKU_WITH_NOMINAL_SPEED_REQUEST';
export const CREATE_SKU_WITH_NOMINAL_SPEED_SUCCESS =
  'CREATE_SKU_WITH_NOMINAL_SPEED_SUCCESS';
export const CREATE_SKU_WITH_NOMINAL_SPEED_ERROR =
  'CREATE_SKU_WITH_NOMINAL_SPEED_ERROR';

export const UPDATE_SKU_WITH_NOMINAL_SPEED_REQUEST =
  'UPDATE_SKU_WITH_NOMINAL_SPEED_REQUEST';
export const UPDATE_SKU_WITH_NOMINAL_SPEED_SUCCESS =
  'UPDATE_SKU_WITH_NOMINAL_SPEED_SUCCESS';
export const UPDATE_SKU_WITH_NOMINAL_SPEED_ERROR =
  'UPDATE_SKU_WITH_NOMINAL_SPEED_ERROR';

export const GET_WORK_ORDER_BY_MACHINE_REQUEST =
  'GET_WORK_ORDER_BY_MACHINE_REQUEST';
export const GET_WORK_ORDER_BY_MACHINE_SUCCESS =
  'GET_WORK_ORDER_BY_MACHINE_SUCCESS';
export const GET_WORK_ORDER_BY_MACHINE_ERROR =
  'GET_WORK_ORDER_BY_MACHINE_ERROR';

export const RESET_WORK_ORDER_BY_MACHINE = 'RESET_WORK_ORDER_BY_MACHINE';
export const GET_QUALITIES_REQUEST = 'GET_QUALITIES_REQUEST';
export const GET_QUALITIES_SUCCESS = 'GET_QUALITIES_SUCCESS';
export const GET_QUALITIES_ERROR = 'GET_QUALITIES_ERROR';
export const CREATE_QUALITIES_REQUEST = 'CREATE_QUALITIES_REQUEST';
export const CREATE_QUALITIES_SUCCESS = 'CREATE_QUALITIES_SUCCESS';
export const CREATE_QUALITIES_ERROR = 'CREATE_QUALITIES_ERROR';
export const DELETE_QUALITIES_REQUEST = 'DELETE_QUALITIES_REQUEST';
export const DELETE_QUALITIES_SUCCESS = 'DELETE_QUALITIES_SUCCESS';
export const DELETE_QUALITIES_ERROR = 'DELETE_QUALITIES_ERROR';
export const UPDATE_QUALITY_REQUEST = 'UPDATE_QUALITY_REQUEST';
export const UPDATE_QUALITY_SUCCESS = 'UPDATE_QUALITY_SUCCESS';
export const UPDATE_QUALITY_ERROR = 'UPDATE_QUALITY_ERROR';
export const CREATE_NOMINAL_SPEED_WITH_MULTIPLE_MACHINES_REQUEST =
  'CREATE_NOMINAL_SPEED_WITH_MULTIPLE_MACHINES_REQUEST';
export const CREATE_NOMINAL_SPEED_WITH_MULTIPLE_MACHINES_SUCCESS =
  'CREATE_NOMINAL_SPEED_WITH_MULTIPLE_MACHINES_SUCCESS';
export const CREATE_NOMINAL_SPEED_WITH_MULTIPLE_MACHINES_ERROR =
  'CREATE_NOMINAL_SPEED_WITH_MULTIPLE_MACHINES_ERROR';
export const RESET_IS_WORK_ORDER_DELETED = 'RESET_IS_WORK_ORDER_DELETED';

export const IMPORT_WORK_ORDERS_REQUEST = 'IMPORT_WORK_ORDERS_REQUEST';
export const IMPORT_WORK_ORDERS_SUCCESS = 'IMPORT_WORK_ORDERS_SUCCESS';
export const IMPORT_WORK_ORDERS_ERROR = 'IMPORT_WORK_ORDERS_ERROR';
export const GET_WORK_ORDER_EXPORT_DATA_REQUEST =
  'GET_WORK_ORDER_EXPORT_DATA_REQUEST';
export const GET_WORK_ORDER_EXPORT_DATA_SUCCESS =
  'GET_WORK_ORDER_EXPORT_DATA_SUCCESS';
export const GET_WORK_ORDER_EXPORT_DATA_ERROR =
  'GET_WORK_ORDER_EXPORT_DATA_ERROR';
export const FETCH_RAW_MATERIALS_REQUEST = 'FETCH_RAW_MATERIALS_REQUEST';
export const FETCH_RAW_MATERIALS_SUCCESS = 'FETCH_RAW_MATERIALS_SUCCESS';
export const FETCH_RAW_MATERIALS_ERROR = 'FETCH_RAW_MATERIALS_ERROR';
